import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/case';

const namespace = 'LITIGATION';

export const SET_BACK_CASE = `${namespace}/SET_BACK_CASE`;

export function setBackCase({ caseID, fromSearchType, offerID }) {
  return async dispatch => {
    dispatch({
      type: SET_BACK_CASE,
      data: {
        caseID,
        fromSearchType,
        offerID,
      },
    });
  };
}

export const QUICK_CASE_LOOKUP_START = `${namespace}/QUICK_CASE_LOOKUP_START`;
export const QUICK_CASE_LOOKUP_SUCCESS = `${namespace}/QUICK_CASE_LOOKUP_SUCCESS`;
export const QUICK_CASE_LOOKUP_ERROR = `${namespace}/QUICK_CASE_LOOKUP_ERROR`;

export const quickCaseLookup = makeApiActionCreatorV3(
  api.quickCaseLookup,
  QUICK_CASE_LOOKUP_START,
  QUICK_CASE_LOOKUP_SUCCESS,
  QUICK_CASE_LOOKUP_ERROR,
);

export const CREATE_CASE_START = `${namespace}/CREATE_CASE_START`;
export const CREATE_CASE_SUCCESS = `${namespace}/CREATE_CASE_SUCCESS`;
export const CREATE_CASE_ERROR = `${namespace}/CREATE_CASE_ERROR`;

export const createCase = makeApiActionCreatorV3(
  api.createCase,
  CREATE_CASE_START,
  CREATE_CASE_SUCCESS,
  CREATE_CASE_ERROR,
);

export const FETCH_CASE_START = `${namespace}/FETCH_CASE_START`;
export const FETCH_CASE_SUCCESS = `${namespace}/FETCH_CASE_SUCCESS`;
export const FETCH_CASE_ERROR = `${namespace}/FETCH_CASE_ERROR`;

export const fetchCase = makeApiActionCreatorV3(
  api.fetchCase,
  FETCH_CASE_START,
  FETCH_CASE_SUCCESS,
  FETCH_CASE_ERROR,
);

export const UPDATE_CASE_START = `${namespace}/UPDATE_CASE_START`;
export const UPDATE_CASE_SUCCESS = `${namespace}/UPDATE_CASE_SUCCESS`;
export const UPDATE_CASE_ERROR = `${namespace}/UPDATE_CASE_ERROR`;

export const updateCase = makeApiActionCreatorV3(
  api.updateCase,
  UPDATE_CASE_START,
  UPDATE_CASE_SUCCESS,
  UPDATE_CASE_ERROR,
);

export const SET_ACTIVE_CASE = `${namespace}/SET_ACTIVE_CASE`;
export const setActiveCase = payload => ({
  type: SET_ACTIVE_CASE,
  payload,
});

export const UPDATE_CASE_TAX_YEARS_START = `${namespace}/UPDATE_CASE_TAX_YEARS_START`;
export const UPDATE_CASE_TAX_YEARS_SUCCESS = `${namespace}/UPDATE_CASE_TAX_YEARS_SUCCESS`;
export const UPDATE_CASE_TAX_YEARS_ERROR = `${namespace}/UPDATE_CASE_TAX_YEARS_ERROR`;

export const updateCaseTaxYears = makeApiActionCreatorV3(
  api.updateCaseTaxYears,
  UPDATE_CASE_TAX_YEARS_START,
  UPDATE_CASE_TAX_YEARS_SUCCESS,
  UPDATE_CASE_TAX_YEARS_ERROR,
);

export const RESET_ACTIVE_CASE = `${namespace}/RESET_ACTIVE_CASE`;
export const resetActiveCase = () => ({ type: RESET_ACTIVE_CASE });

export const FETCH_CASE_SUMMARY_START = `${namespace}/FETCH_CASE_SUMMARY_START`;
export const FETCH_CASE_SUMMARY_SUCCESS = `${namespace}/FETCH_CASE_SUMMARY_SUCCESS`;
export const FETCH_CASE_SUMMARY_ERROR = `${namespace}/FETCH_CASE_SUMMARY_ERROR`;

export const fetchCaseSummary = makeApiActionCreatorV3(
  api.fetchCaseSummary,
  FETCH_CASE_SUMMARY_START,
  FETCH_CASE_SUMMARY_SUCCESS,
  FETCH_CASE_SUMMARY_ERROR,
);

export const REOPEN_CASE_START = `${namespace}/REOPEN_CASE_START`;
export const REOPEN_CASE_SUCCESS = `${namespace}/REOPEN_CASE_SUCCESS`;
export const REOPEN_CASE_ERROR = `${namespace}/REOPEN_CASE_ERROR`;

export const reopenCase = makeApiActionCreatorV3(
  api.reopenCase,
  REOPEN_CASE_START,
  REOPEN_CASE_SUCCESS,
  REOPEN_CASE_ERROR,
);

export const FETCH_ROLL_CORRS_START = `${namespace}/FETCH_ROLL_CORRS_START`;
export const FETCH_ROLL_CORRS_SUCCESS = `${namespace}/FETCH_ROLL_CORRS_SUCCESS`;
export const FETCH_ROLL_CORRS_ERROR = `${namespace}/FETCH_ROLL_CORRS_ERROR`;

export const fetchRollCorrs = makeApiActionCreatorV3(
  api.fetchRollCorrs,
  FETCH_ROLL_CORRS_START,
  FETCH_ROLL_CORRS_SUCCESS,
  FETCH_ROLL_CORRS_ERROR,
);

export const FINALIZE_CASE_START = `${namespace}/FINALIZE_CASE_START`;
export const FINALIZE_CASE_SUCCESS = `${namespace}/FINALIZE_CASE_SUCCESS`;
export const FINALIZE_CASE_ERROR = `${namespace}/FINALIZE_CASE_ERROR`;

export const finalizeCase = makeApiActionCreatorV3(
  api.finalizeCase,
  FINALIZE_CASE_START,
  FINALIZE_CASE_SUCCESS,
  FINALIZE_CASE_ERROR,
);

export const simpleFinalizeCase = makeApiActionCreatorV3(
  api.simpleFinalizeCase,
  FINALIZE_CASE_START,
  FINALIZE_CASE_SUCCESS,
  FINALIZE_CASE_ERROR,
);

export const IMPORT_APPEAL_APPRAISERS_START = `${namespace}/IMPORT_APPEAL_APPRAISERS_START`;
export const IMPORT_APPEAL_APPRAISERS_SUCCESS = `${namespace}/IMPORT_APPEAL_APPRAISERS_SUCCESS`;
export const IMPORT_APPEAL_APPRAISERS_ERROR = `${namespace}/IMPORT_APPEAL_APPRAISERS_ERROR`;

export const importAppealAppraisers = makeApiActionCreatorV3(
  api.importAppealAppraisers,
  IMPORT_APPEAL_APPRAISERS_START,
  IMPORT_APPEAL_APPRAISERS_SUCCESS,
  IMPORT_APPEAL_APPRAISERS_ERROR,
);
